import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const partnerTenantEntity: Entity = {
  model: model,
  repository: repository,
}

export default partnerTenantEntity
